/* @flow weak */
import app from "./app/reducer";
import config from "./config/reducer";
import device from "./device/reducer";
import intl from "./intl/reducer";
import auth from "./auth/reducer";
import agency from "./agency/reducer";
import offer from "./offer/reducer";
import application from "./application/reducer";
import admin from "./admin/reducer";
import user from "./user/reducer";
import article from "./article/reducer";
import { combineReducers } from "redux";
import { fieldsReducer as fields } from "./lib/redux-fields";

//const resetStateOnSignOut = (reducer, initialState) => (state, action) => {
//// Reset app state on sign out, stackoverflow.com/q/35622588/233902.
//const userWasSignedOut =
//action.type === 'SIGN_OUT';
//if (userWasSignedOut) {
//// Preserve state without sensitive data.
//state = {
//app: state.app,
//config: initialState.config,
//device: initialState.device,
//intl: initialState.intl,
//};
//}
//return reducer(state, action);
//};

const configureReducer = (initialState: Object) => {
  let reducer = combineReducers({
    app,
    config,
    device,
    fields,
    intl,
    auth,
    agency,
    offer,
    application,
    admin,
    user,
    article
  });

  // The power of higher-order reducers, http://slides.com/omnidan/hor
  //reducer = resetStateOnSignOut(reducer, initialState);

  return reducer;
};

export default configureReducer;



// WEBPACK FOOTER //
// ./src/common/configureReducer.js